module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedExtraBold.5040831.woff";